export const COMPLIANCE_LOGO_LIST = [
	{
		name: 'ComplianceLogo3',
		index: '1',
		title: 'complianceLogoType3',
		category: 'compliance',
		selected: false,
		backgroundImage:
			'https://res.cloudinary.com/uwm/image/upload/v1568928155/compliance-logos/ComplianceLogoType3.png',
	},
	{
		name: 'ComplianceLogo4',
		index: '2',
		title: 'complianceLogoType4',
		category: 'compliance',
		selected: false,
		backgroundImage:
			'https://res.cloudinary.com/uwm/image/upload/v1568928150/compliance-logos/ComplianceLogoType4.png',
	},
	{
		name: 'ComplianceLogo5',
		index: '3',
		title: 'complianceLogoType5',
		category: 'compliance',
		selected: false,
		backgroundImage:
			'https://res.cloudinary.com/uwm/image/upload/v1568928142/compliance-logos/ComplianceLogoType5.png',
	},
	{
		name: 'ComplianceLogo1',
		index: '4',
		title: 'complianceLogoType1',
		category: 'compliance',
		selected: false,
		backgroundImage:
			'https://res.cloudinary.com/uwm/image/upload/v1568928166/compliance-logos/ComplianceLogoType1.png',
	},
	{
		name: 'ComplianceLogo2',
		index: '5',
		title: 'complianceLogoType2',
		category: 'compliance',
		selected: false,
		backgroundImage:
			'https://res.cloudinary.com/uwm/image/upload/v1568928161/compliance-logos/ComplianceLogoType2.png',
	},
	{
		name: 'ComplianceLogo6',
		index: '6',
		title: 'complanceLogoType6', //TODO: Compliance is misspelled for type 6 everywhere
		category: 'compliance',
		selected: false,
	},
	{
		name: 'ComplianceLogo7',
		index: '7',
		title: 'complianceLogoType7',
		category: 'compliance',
		selected: false,
		backgroundImage:
			'https://res.cloudinary.com/uwm/image/upload/v1568928161/compliance-logos/MSIC_Logo.jpg',
	},
	{
		name: 'ComplianceLogo8',
		index: '8',
		title: 'complianceLogoType8',
		category: 'compliance',
		selected: false,
		backgroundImage:
			'https://res.cloudinary.com/uwm/image/upload/v1571335276/compliance-logos/ComplianceLogoType8.png',
	},
];
